import ScrollReveal from 'scrollreveal';
import { TweenMax, TimelineMax } from 'gsap';

export function initScrollReveal() {
  const easing = 'cubic-bezier(.2,.98,.57,1)';
  const duration = 2400;
  const delay = duration / 4;

  const slideUp = {
    distance: '100px',
    duration,
    origin: 'bottom',
    opacity: 0,
    easing,
  };

  const fadeIn = {
    distance: 0,
    duration,
    opacity: 0,
    easing,
  };

  ScrollReveal.debug = true;
  ScrollReveal().reveal('.slide-up', slideUp);
  ScrollReveal().reveal('.slide-up-delay', { ...slideUp, delay });

  ScrollReveal().reveal('.fade-in', fadeIn);
  ScrollReveal().reveal('.fade-in-delay', { ...slideUp, delay });

}
